import { render, staticRenderFns } from "./StudentInSchool.vue?vue&type=template&id=5d45db3c&scoped=true"
import script from "./StudentInSchool.vue?vue&type=script&lang=js"
export * from "./StudentInSchool.vue?vue&type=script&lang=js"
import style0 from "./StudentInSchool.vue?vue&type=style&index=0&id=5d45db3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45db3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d45db3c')) {
      api.createRecord('5d45db3c', component.options)
    } else {
      api.reload('5d45db3c', component.options)
    }
    module.hot.accept("./StudentInSchool.vue?vue&type=template&id=5d45db3c&scoped=true", function () {
      api.rerender('5d45db3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/StudentInSchool.vue"
export default component.exports